import React, { Component } from 'react';
import logo from '../../img/s-v-t.svg';
import testScreen from '../../img/test-screen.png';
import portraitScreen from '../../img/portrait_screenshot.jpg';
import './StartPage.css';
import { Button, Glyphicon } from 'react-bootstrap';
import { nextVideo } from "../../redux/actions";
import { connect } from "react-redux";
import { ALLOW_COMMENTS, NUMBER_OF_VIDEOS } from '../../services/config'

class StartPage extends Component {
    constructor() {
        super();
        this.state = { hevcSupport: false }
    }

    componentDidMount() {
        this.getMediaCapabilities();
    }
    getScreenshot = () => {
        if (this.props.videotest.get("device")) {
            const orientation = this.props.videotest.get("device").screen.orientation;
            if (orientation === "portrait") {
                return portraitScreen
            }
            else {
                return testScreen
            }
        }
        else {
            return testScreen
        }
    }

    videoConfiguration = {
        type: 'file',
        video: {
            contentType: 'video/mp4; codecs="hvc1.2.4.L153"',
            width: 1920,
            height: 1080,
            bitrate: 2100000,
            framerate: 25
        }
    }

    getMediaCapabilities = () => {
        navigator.mediaCapabilities.decodingInfo(this.videoConfiguration).then((result) => {
            this.setState({ hevcSupport: result.supported })
        })
    }
    render() {
        return (
            <div className="App">
                <div className="App-header">
                    <h1>
                        <img src={logo} className="App-logo" alt="logo" />
                    </h1>
                </div>

                <div className="TextArea">
                    {this.state.hevcSupport && (
                        <div>
                            <h1>Välkommen till SVT Plays videokvalitetstest</h1>

                            <p>Ditt deltagande hjälper oss att göra SVT Play bättre, och vi är otroligt tacksamma att du tar dig tiden att delta!
                            </p>
                            <h4>Varför gör vi testet?</h4>
                            <p>I det här testet undersöker vi huruvida vår egendesignade adaptiva kvantisering kan förbättra den visuella kvalitetsupplevelsen vid dålig uppkoppling. Testet är en del i vårt ständigt pågående arbete att förbättra användarupplevelsen i SVT Play.
                            </p>
                            <h4>Hur gör du testet?</h4>
                            <p>
                                Du kan göra testet via webbläsaren på din <b>dator</b>, <b>mobil</b>, eller <b>surfplatta</b>. Det finns <b>inget rätt eller fel svar</b>, testet handlar om hur du upplever videon.
                            </p>
                            <h4>
                                Hur går testet till?
                            </h4>
                            <ul>
                                <li>
                                    När testet startar kommer du ha två videoklipp framför dig: <b>Alternativ 1</b> och <b>Alternativ 2</b>. Du kan starta klippen i vilken ordning du vill, och kan spela dem hur många gånger som helst.
                                </li>
                                <li>
                                    Allt du behöver göra är att titta på de två klippen och avgöra om du tycker att bilden ser bättre ut i något av dem. Detta gör du med hjälp av knappar som är placerade under spelaren.
                                </li>
                                <li>
                                    När du satt ditt betyg trycker du på knappen "Nästa" för att gå till nästa videojämförelse.
                                </li>
                                {ALLOW_COMMENTS && (<li>
                                    På sista sidan finns det möjlighet att lämna en kommentar.
                                </li>)}
                            </ul>
                            <div>
                                <h4>Så här ser testet ut:</h4>
                                <img src={this.getScreenshot()} className="test-screen" alt={"Skärmavbild från testet"} />
                            </div>
                            <p>
                                Testet innehåller totalt {NUMBER_OF_VIDEOS} jämförelser som alla är mellan 10 och 30 sekunder långa.
                            </p>
                            <h4>Bra att veta:</h4>
                            <p>
                                Eftersom dessa klipp består av två videofiler som spelas samtidigt så rekommenderar vi att du <b>inte använder mobildata</b>. Detta innebär också att det ibland tar ett litet tag för klippen att ladda och börja spela. Vänta då på att det händer, och uppdatera inte sidan, då börjar nämligen testet om från början.
                            </p>
                            <h4>Vilken information sparas?</h4>
                            <p>
                                Förutom dina bedömningar sparar vi information om enheten du gör testet på, och kommer i slutet av testet fråga om vilken åldersgrupp du tillhör. Ingen personlig information sparas.
                            </p>
                            <h4>Tack för att du deltar!</h4>
                        </div>
                    )}
                    {(!this.state.hevcSupport && (
                        <div>
                            <p>Din enhet kan tyvärr inte användas för det här testet. Pröva att öppna sidan på en annan enhet eller i en annan webbläsare.</p>
                        </div>
                    ))}
                </div>

                {this.state.hevcSupport && (<Button className="btn btn-primary"
                    onClick={this.props.nextVideo}
                >
                    Starta testet <Glyphicon glyph="step-forward" />
                </Button>)}
            </div >
        );
    }
}


const mapStateToProps = state => ({
    videotest: state.get("videotest")
});

const mapDispatchToProps = dispatch => {
    return {
        nextVideo: () => dispatch(nextVideo())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartPage);



// WEBPACK FOOTER //
// ./src/components/StartPage/StartPage.js